import axios from './axios'
import config from '../config'

export default {
    listNews(params) {
        return axios({
            url: config.backendUrl + '/common/news-edit/list',
            method: 'GET',
            params
        })
    },
    getNewsDetails(params) {
        return axios({
            url: config.backendUrl + '/common/news-edit/details',
            method: 'GET',
            params
        })
    },
    deleteNews(params) {
        return axios({
            url: config.backendUrl + '/common/news-edit/delete',
            method: 'POST',
            params
        })
    },
    restoreNews(params) {
        return axios({
            url: config.backendUrl + '/common/news-edit/restore',
            method: 'POST',
            params
        })
    },
    updateNews(params, data) {
        return axios({
            url: config.backendUrl + '/common/news-edit/update',
            method: 'POST',
            params,
            data
        })
    },
    addNews(params, data) {
        return axios({
            url: config.backendUrl + '/common/news-edit/add',
            method: 'POST',
            params,
            data
        })
    }
}
